import { useContext } from 'react';
import { DependencyContainerReactContext } from './DependencyContainerReactContext';

export function useInstance<T>(dependencyKey: { new(...args: any[]): T }): T {
    const { container } = useContext(DependencyContainerReactContext);

    if (!container){
        throw new Error('expected to be in context of DependencyContainerReactContext but useContext(DependencyContainerReactContext) resulted in no container');
    }
    return container.get(dependencyKey) as T;
}
